import { r as e, t } from "./shapes-BQUVJdp5.js";
import { Fragment as n, computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, createTextVNode as c, createVNode as l, defineAsyncComponent as u, defineComponent as d, onMounted as f, onUnmounted as p, openBlock as m, ref as h, renderList as g, resolveComponent as _, toDisplayString as v, watch as y, withCtx as b } from "vue";
import { AudioAutoPlayer as x, Question as S, RadioMultipleChoice as C, containsComponent as w, isInlineComponent as T, splitByDelimiters as E, useQuestionView as D, useViewable as O } from "@vue-skuilder/common-ui";
import "@vue-skuilder/common";
import './assets/CourseWare.css';//#region src/math/utility/index.ts
function randomInt(e, t) {
	return Math.floor(Math.random() * (t - e + 1)) + e;
}
function shuffle(e) {
	let t = [...e];
	for (let e = t.length - 1; e > 0; e--) {
		let n = Math.floor(Math.random() * (e + 1));
		[t[e], t[n]] = [t[n], t[e]];
	}
	return t;
}
function cos(e) {
	return Math.cos(toRadians(e));
}
function sin(e) {
	return Math.sin(toRadians(e));
}
function toRadians(e) {
	return e / 360 * 2 * Math.PI;
}
//#endregion
//#region src/default/questions/fillIn/blanksCorrection.ts
function gradeSpellingAttempt(e, t) {
	let n = Array(t.length).fill("_"), r = e.split("");
	console.log(e, t), console.log("Attempt char codes:", e.split("").map((e) => e.charCodeAt(0))), console.log("Answer char codes:", t.split("").map((e) => e.charCodeAt(0)));
	for (let e = 0; e < t.length; e++) e < r.length && r[e] === t[e] && (n[e] = r[e], r[e] = "");
	for (let e = t.length - 1; e >= 0; e--) if (n[e] === "_") {
		let i = r.findIndex((n) => n === t[e]);
		i !== -1 && (n[e] = t[e], r[i] = "");
	}
	return console.log(n.join(" ")), n.join(" ");
}
//#endregion
//#region src/default/questions/fillIn/fillIn.vue?vue&type=script&lang.ts
var k = d({
	name: "FillInView",
	components: {
		MarkdownRenderer: u(() => import("@vue-skuilder/common-ui").then((e) => e.MarkdownRenderer)),
		RadioMultipleChoice: C,
		AudioAutoPlayer: x
	},
	props: {
		data: {
			type: Array,
			required: !0
		},
		modifyDifficulty: {
			type: Number,
			required: !1,
			default: 0
		}
	},
	setup(e, { emit: t }) {
		let n = O(e, t, "FillInView"), i = D(n);
		i.question.value = new I(e.data);
		let a = h(), o = r(() => {
			if (!i.question.value) throw n.logger.error("Question not initialized"), Error("Question not initialized");
			return i.question.value;
		});
		f(() => {
			try {
				i.question.value || (i.question.value = new I(e.data)), i.question.value.options && (a.value = shuffle(getTruncatedList()));
			} catch (e) {
				n.logger.error("Failed to initialize question:", e);
			}
		}), p(() => {
			i.question.value = void 0;
		});
		let s = r(() => a.value ?? []), c = r(() => !!e.data[0]["image-1"]), l = r(() => {
			if (!c.value) return [""];
			let t = [], n = 1;
			for (; e.data[0][`image-${n}`];) t.push(URL.createObjectURL(e.data[0][`image-${n}`])), n++;
			return t;
		}), u = r(() => !!e.data[0]["audio-1"]), d = r(() => o.value?.mdText || ""), m = r(() => {
			if (!u.value) return [""];
			let t = [], n = 1;
			for (; e.data[0][`audio-${n}`];) t.push(URL.createObjectURL(e.data[0][`audio-${n}`])), n++;
			return t;
		}), g = r(() => {
			if (o.value.answers) return o.value.answers[Math.floor(o.value.answers.length * Math.random())];
			throw Error("No answers provided");
		}), _ = r(() => {
			let e = g.value;
			if (console.log(`Prior answers: ${i.priorAnswers.value}`), e && i.priorAnswers.value[0]?.[0] && i.priorAnswers.value[0][1] === "UserInputString") return gradeSpellingAttempt(i.priorAnswers.value[0][0], e);
			if (console.log("found no UserInputString"), g.value) {
				let e = "";
				for (let t = 0; t < g.value.length; t++) e += "_ ";
				return e;
			}
			return "";
		}), v = r(() => !!(o.value.answers && o.value.answers.length > 0)), getTruncatedList = () => {
			if (!o.value?.options) return;
			if (o.value.options.length <= 6) return o.value.options;
			let t = [];
			t.push(o.value.answers[Math.floor(Math.random() * o.value.answers.length)]);
			let n = shuffle(o.value.options.filter((e) => o.value.answers?.indexOf(e) === -1));
			return e.modifyDifficulty && (console.log(`Modifying difficulty: ${e.modifyDifficulty}`), n = e.modifyDifficulty < -200 ? n.slice(0, 1) : e.modifyDifficulty < -150 ? n.slice(0, 2) : e.modifyDifficulty < -100 ? n.slice(0, 3) : e.modifyDifficulty < -50 ? n.slice(0, 4) : n.slice(0, 5)), t.push(...n.slice(0, 5)), t;
		}, handleNext = () => {
			i.submitAnswer("");
		};
		return y(() => e.data, (e) => {
			try {
				i.question.value = new I(e), i.question.value?.options && (a.value = shuffle(getTruncatedList()));
			} catch (e) {
				n.logger.error("Failed to initialize/update question:", e);
			}
		}, { deep: !0 }), {
			...n,
			...i,
			question: o,
			truncatedOptions: s,
			hasImage: c,
			imageURLs: l,
			hasAudio: u,
			audioURL: m,
			obscuredAnswer: _,
			someAnswer: g,
			isQuestion: v,
			handleNext,
			markdownText: d
		};
	}
}), A = /* @__PURE__ */ e((e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, "default"), j = { "data-viewable": "FillInView" }, M = ["src"], N = {
	key: 4,
	class: "text-center text-h6"
}, P = {
	key: 5,
	class: "text-center text-h6"
};
function _sfc_render(e, t, r, u, d, f) {
	let p = _("audio-auto-player"), h = _("markdown-renderer"), y = _("radio-multiple-choice"), x = _("v-spacer"), S = _("v-btn"), C = _("v-card-actions");
	return m(), o("div", j, [
		e.hasAudio ? (m(), i(p, {
			key: 0,
			src: e.audioURL
		}, null, 8, ["src"])) : a("", !0),
		e.hasImage ? (m(!0), o(n, { key: 1 }, g(e.imageURLs, (e, t) => (m(), o("img", {
			key: t,
			src: e
		}, null, 8, M))), 128)) : a("", !0),
		e.markdownText ? (m(), i(h, {
			key: 2,
			md: e.markdownText
		}, null, 8, ["md"])) : a("", !0),
		e.question?.options ? (m(), i(y, {
			key: 3,
			"choice-list": e.truncatedOptions
		}, null, 8, ["choice-list"])) : e.priorAttempts == 1 ? (m(), o("div", N, [s("span", null, v(e.obscuredAnswer), 1)])) : e.priorAttempts == 2 ? (m(), o("div", P, [s("span", null, v(e.someAnswer), 1)])) : a("", !0),
		e.isQuestion ? a("", !0) : (m(), i(C, { key: 6 }, {
			default: b(() => [l(x), l(S, {
				color: "primary",
				autofocus: "autofocus",
				onClick: e.handleNext
			}, {
				default: b(() => t[0] ||= [c(" Next ")]),
				_: 1
			}, 8, ["onClick"])]),
			_: 1
		}))
	]);
}
var F = /* @__PURE__ */ A(k, [["render", _sfc_render], ["__scopeId", "data-v-f91502f8"]]);
//#endregion
//#region src/default/questions/fillIn/index.ts
function splitText(e, t, n) {
	let r = e.split(t), i = r[0], a = r[1].split(n);
	return {
		left: i,
		middle: a[0],
		right: a[1]
	};
}
var I = class BlanksCard extends S {
	static dataShapes = t;
	static views = [F];
	mdText = "";
	answers = null;
	options = null;
	splitTextToken(e) {
		if (w(e)) {
			let t = splitText(e.text, "{{", "}}"), n = splitText(e.raw, "{{", "}}"), r = [];
			return n.left.length > 0 && r.push({
				type: "text",
				raw: n.left,
				text: t.left
			}), n.middle.length > 0 && r.push({
				type: "text",
				raw: "{{" + n.middle + "}}",
				text: "{{" + t.middle + "}}"
			}), n.right.length > 0 && r.push({
				type: "text",
				raw: n.right,
				text: t.right
			}), r;
		} else return [e];
	}
	optionsFromString(e) {
		if (!e.startsWith("{{") || !e.endsWith("}}")) throw Error(`string ${e} is not fill-in text - must look like "{{someText}}"`);
		e = e.substring(2, e.length - 2);
		let t = e.split("||");
		if (t.length > 1) {
			let e = t[0].split("|").map((e) => e.trim()), n = t[1].split("|").map((e) => e.trim()).filter((t) => !e.includes(t));
			return n.push(e[randomInt(0, e.length - 1)]), {
				answers: e,
				options: shuffle(n)
			};
		} else return {
			answers: [e.trim()],
			options: null
		};
	}
	constructor(e) {
		super(e), this.mdText = e[0].Input, this.mdText === void 0 && (this.mdText = "");
		let t = E(this.mdText, "{{", "}}"), n = [];
		for (let e = 0; e < t.length; e++) {
			let r = t[e], i = r.trim();
			if (i.startsWith("{{") && i.endsWith("}}")) if (T(i.slice(2, -2).trim())) n.push(r);
			else try {
				let e = this.optionsFromString(r);
				this.answers = e.answers, this.options = e.options, this.options?.length ? n.push("{{ || }}") : n.push("{{ }}");
			} catch {
				n.push(r);
			}
			else n.push(r);
		}
		this.mdText = n.join("");
	}
	isCorrect(e) {
		if (console.log(`answers:${this.answers}\nuser answer: ${JSON.stringify(e)}`), typeof e == "string") {
			if (this.answers) return this.answers.includes(e);
			if (e === "") return !0;
			throw Error("Question has no configured answers!");
		} else if (Array.isArray(e)) {
			if (this.answers) return e.every((e) => this.answers.includes(e));
			throw Error("Question has no configured answers!");
		} else return this.isCorrectRadio(e);
	}
	dataShapes() {
		return BlanksCard.dataShapes;
	}
	views() {
		return BlanksCard.views;
	}
	isCorrectRadio(e) {
		return this.answers ? this.answers.includes(e.choiceList[e.selection]) : !1;
	}
}, CourseWare = class {
	get questions() {
		return this.questionList;
	}
	get allViews() {
		let e = [];
		return this.questionList.forEach((t) => {
			t.views.forEach((t) => {
				e.push(t);
			});
		}), e;
	}
	get allViewsMap() {
		let e = {};
		return this.allViews.forEach((t) => {
			if (t.name) e[t.name] = t;
			else throw Error("View has no name");
		}), e;
	}
	name;
	questionList;
	constructor(e, t) {
		this.name = e, this.questionList = t, this.questionList = this.questionList.concat(this.getBaseQTypes());
	}
	getQuestion(e) {
		let t = e.replace(/^_/, "").replace(/\d+$/, ""), n = this.questionList.map((e) => e.name), r = this.questionList.find((n) => {
			let r = n.name.replace(/^_/, "").replace(/\d+$/, "");
			return n.name === e || r === t;
		});
		if (r) return r.name !== e && console.debug(`[CourseWare.getQuestion] stripped-exact: "${e}" → "${r.name}" (registered: ${n.join(", ")})`), r;
		let i = this.questionList.filter((n) => {
			let r = n.name.replace(/^_/, "").replace(/\d+$/, "");
			return n.name.includes(t) || e.includes(r);
		});
		if (i.length === 0) {
			console.warn(`[CourseWare.getQuestion] NO MATCH: "${e}" (base: "${t}") not found in [${n.join(", ")}]`);
			return;
		}
		i.sort((t, n) => Math.abs(t.name.length - e.length) - Math.abs(n.name.length - e.length));
		let a = i[0];
		return console.warn(`[CourseWare.getQuestion] FUZZY: "${e}" → "${a.name}" (candidates: ${i.map((e) => e.name).join(", ")}; registered: ${n.join(", ")})`), a;
	}
	getBaseQTypes() {
		return [I];
	}
};
//#endregion
export { cos as a, sin as c, gradeSpellingAttempt as i, I as n, randomInt as o, A as r, shuffle as s, CourseWare as t };

//# sourceMappingURL=CourseWare-BTFRjgBR.js.map